<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'businessIntelligence.relatorioCoaf.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.relatorioCoaf.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'businessIntelligence.relatorioCoaf.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.relatorioCoaf.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate"
                  (onClearClick)="limpaDataFinal()"
                  placeholder="{{'businessIntelligence.relatorioCoaf.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'businessIntelligence.relatorioCoaf.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'businessIntelligence.relatorioCoaf.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="text-center mt-4 mb-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem; color: #007bff;"></i>
    </div>
    <div translate *ngIf="!loading && dados?.length <= 0" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.relatorioCoaf.nenhumRegistroExibir'}}
    </div>
    <p-table #dt *ngIf="dados?.length > 0" [value]="dados" dataKey="_rowId" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dados?.length > 10" [rows]="10" [loading]="loading" [columns]="cols" [autoLayout]="true"
      [rowHover]="true" [scrollable]="true"
      currentPageReportTemplate="{{'businessIntelligence.relatorioCoaf.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
      [globalFilterFields]="globalFilterFields" id="excel-table">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'businessIntelligence.relatorioCoaf.filtroGeral' | translate}}" />
          </span>

          <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="field"
            selectedItemsLabel="{{'businessIntelligence.relatorioCoaf.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'businessIntelligence.relatorioCoaf.colunasSelecionadasPlaceHolder' | translate}}">
            <ng-template let-col pTemplate="item">
              {{ col.header | translate }}
            </ng-template>
            <ng-template let-col pTemplate="selectedItem">
              {{ col.header | translate }}
            </ng-template>
          </p-multiSelect>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th translate class="text-center" style="background-color:black;color:white;"
            *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <em class="fa fa-sort fa-xs float-right" [attr.field]="col.field"></em>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td class="text-center" *ngFor="let col of columns"
              [ngClass]="{'status-atencao-cell': col.field === 'status' && getValorCelula(dados, col) === 'Atenção'}" [ngClass]="{'status-atencao-cell': col.field === 'status' && getValorCelula(dados, col) === 'Atenção'}">
            <div *ngIf="col.field !== 'descricaoMercadoria'">{{ getValorCelula(dados, col) }}</div>
            <div *ngIf="col.field === 'descricaoMercadoria'" [title]="dados.descricaoMercadoriaHint">
              {{ dados.descricaoMercadoriaPreview || getValorCelula(dados, col) }}<span *ngIf="dados.descricaoMercadoriaHint">...</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="{{'businessIntelligence.relatorioCoaf.filtros.definirFiltros' | translate}}"
  [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true" [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.relatorioCoaf.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-multiSelect appendTo="body" [options]="gruposEconomicos" formControlName="grupo_economico"
            optionLabel="descricao" optionValue="id" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm"
            placeholder="{{'businessIntelligence.relatorioCoaf.grupoEconomicoPlaceHolder' | translate}}"
            selectedItemsLabel="{{'businessIntelligence.relatorioCoaf.gruposSelecionados' | translate}}"
            [maxSelectedLabels]="2">
          </p-multiSelect>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'businessIntelligence.relatorioCoaf.filtrar'}}</button>
  </ng-template>
</p-dialog>

<app-filtro-dealers [(visible)]="displayFiltrosDealers" [dealers]="filtrosDealers.dealers"
  [headerTitle]="'businessIntelligence.relatorioCoaf.selecioneDealers'"
  [filterPlaceholder]="'businessIntelligence.relatorioCoaf.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>
